import axios from "../api";
/**
 * `POST /objectives/bundles`: rebuilds the user's one bundle in place, dropping
 * its stacked plan, squads and progress. An empty bundle deletes it and resolves to
 * null (204).
 */
export const buildObjectiveBundle = async (body, signal) => {
    const res = await axios.post("/objectives/bundles", body, { signal });
    return res.data || null;
};
/** `GET /objectives/bundles/latest`: the user's newest build, or null. */
export const getLatestObjectiveBundle = async () => {
    const res = await axios.get("/objectives/bundles/latest");
    return res.data || null;
};
/** `GET /objectives/bundles/:id`: 404 `OBJECTIVE_BUNDLE_NOT_FOUND` unless it is the caller's. */
export const getObjectiveBundle = async (id) => {
    const res = await axios.get(`/objectives/bundles/${id}`);
    return res.data;
};
/** `POST /objectives/bundles/:id/stacked-plan`: adds the stacked plan to the current build (once). */
export const buildObjectiveBundleStackedPlan = async (id) => {
    const res = await axios.post(`/objectives/bundles/${id}/stacked-plan`);
    return res.data;
};
/**
 * `POST /objectives/bundles/:id/squads`: starts building one squad per block of
 * the view and returns at once; poll `getObjectiveBundle` for the squads.
 * 409 `OBJECTIVE_SQUADS_RUNNING` while another run of the user is going.
 */
export const startObjectiveSquads = async (id, view, 
/** Stored on the bundle; the plan is not rebuilt. */
settings, 
/** Block indexes whose built squad stays as is. */
keepBlocks = []) => {
    const res = await axios.post(`/objectives/bundles/${id}/squads`, { view, ...settings, keepBlocks });
    return res.data;
};
/**
 * `GET /objectives/bundles/:id/squads/:view?from=k`: the squad run from block
 * `k` on, for polling (blocks build in order); null when the view has no run.
 */
export const getObjectiveSquads = async (id, view, from) => {
    const res = await axios.get(`/objectives/bundles/${id}/squads/${view}`, { params: { from } });
    return res.data || null;
};
/** `POST /objectives/bundles/:id/reveal`: reveals the plan and returns it whole. */
export const revealObjectiveBundle = async (id) => {
    const res = await axios.post(`/objectives/bundles/${id}/reveal`);
    return res.data;
};
/** `POST /objectives/bundles/:id/squads/:view/saved`: records that the view's squads were saved (204). */
export const markObjectiveSquadsSaved = async (id, view) => {
    await axios.post(`/objectives/bundles/${id}/squads/${view}/saved`);
};
/** `PATCH /objectives/bundles/:id/progress`: replaces the view's counts (204). */
export const saveObjectiveBundleProgress = async (id, view, progress) => {
    await axios.patch(`/objectives/bundles/${id}/progress`, { view, progress });
};
/**
 * `PATCH /objectives/bundles/:id/mode`: plays block `block` of the view in another of its
 * `modeOptions` and returns the bundle; 400 `INVALID_OBJECTIVE_MODE` for any other mode.
 */
export const setObjectiveBlockMode = async (id, view, block, mode) => {
    const res = await axios.patch(`/objectives/bundles/${id}/mode`, { view, block, mode });
    return res.data;
};
/** `PATCH /objectives/bundles/:id/view`: remembers the picked plan view (204). */
export const setObjectiveBundleView = async (id, view) => {
    await axios.patch(`/objectives/bundles/${id}/view`, { view });
};
//# sourceMappingURL=objectiveBundles.js.map